import React, { useEffect, useState } from "react";
import { FormProvider, useForm, SubmitHandler } from "react-hook-form";
import BootstrapTable, {
  ColumnDescription,
  PaginationOptions,
} from "fad-react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useHomeState } from "../../_store/Home";
import {
  HomeFromProps,
  CountCase,
  CaseDetail,
  CaseForSale,
  MasterReasonUnFollow,
  UnfollowResponse,
  UpdateRemarkSaleResponse,
  UpdateReceiveServiceDateResponse,
} from "../../_types/Home";
import Spinner from "../../components/spinners/Spinner";
import { useAuth } from "../../context/UseAuth";
import { useHelper } from "../../context/Helper";
import InputFieldComponent, {
  InputMode,
} from "../../components/common/InputField";
import { toast } from "react-toastify";
import Chart from "react-apexcharts";
import JsonViewerComponent from "../../components/common/JsonViewerComponent";
import { DatePicker, Modal } from "rsuite";
import moment from "moment-timezone";
import Select from "react-select";
import { BsCopy, BsBuildingAdd } from "react-icons/bs";
import { FaEllipsisV } from "react-icons/fa";
import ModalAddClient from "../../components/home/ModalAddClient";
import { Input, Label } from "reactstrap";

const MySwal = withReactContent(Swal);
let chartOption: any = {
  series: [
    {
      name: "ยอดการนัดหมาย",
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    {
      name: "ยอดเข้ารับบริการ",
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
  ],
  chart: {
    height: 350,
    type: "line",
    dropShadow: {
      enabled: true,
      color: "#000",
      top: 18,
      left: 7,
      blur: 10,
      opacity: 0.2,
    },
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
  },
  colors: ["#77B6EA", "#545454"],
  dataLabels: {
    enabled: true,
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
    },
    background: {
      enabled: true,
      foreColor: '#fff',
      padding: 4,
      borderRadius: 2,
      borderWidth: 1,
      borderColor: '#fff',
      opacity: 0.9,
    },
  },
  stroke: {
    curve: "smooth",
    width: 3,
  },
  title: {
    text: "",
    align: "left",
  },
  grid: {
    borderColor: "#e7e7e7",
    strokeDashArray: 5,
    row: {
      colors: ["#f3f3f3", "transparent"],
      opacity: 0.5,
    },
    padding: {
      top: 0,
      right: 20,
      bottom: 0,
      left: 10
    }
  },
  markers: {
    size: 5,
    strokeWidth: 2,
    strokeColors: '#fff',
    hover: {
      size: 7,
    }
  },
  xaxis: {
    categories: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    title: {
      text: "เดือน",
      style: {
        fontSize: '14px',
        fontWeight: 600,
      }
    },
    labels: {
      style: {
        fontSize: '12px',
      }
    },
    axisBorder: {
      show: true,
      color: '#78909C',
    },
    axisTicks: {
      show: true,
      color: '#78909C',
    }
  },
  yaxis: {
    labels: {
      style: {
        fontSize: '12px',
      }
    }
  },
  legend: {
    position: "top",
    horizontalAlign: "right",
    floating: true,
    offsetY: -25,
    offsetX: -5,
    fontSize: '14px',
    markers: {
      width: 12,
      height: 12,
      radius: 2,
    }
  },
  tooltip: {
    enabled: true,
    shared: true,
    intersect: false,
    y: {
      formatter: function (val: number) {
        return val + " ราย"
      }
    }
  }
};

const Home = (props: any) => {
  const [chart, setChart] = useState(chartOption);
  const { getMessage } = useHelper();
  const { profile } = useAuth();
  const isLoading = useHomeState((state) => state.isLoading);
  const setIsLoading = useHomeState((state) => state.setIsLoading);
  const getHomePageDetail = useHomeState((state) => state.getHomePage);
  const getCountCase = useHomeState((state) => state.getCountCase);
  const getCaseFilter = useHomeState((state) => state.getCaseFilter);
  const [isOpenPopupAddClient, setIsOpenPopupAddClient] = useState(false);
  const getMasterReasonUnfollow = useHomeState(
    (state) => state.getMasterReasonUnfollow
  );
  const unfollow = useHomeState((state) => state.unfollow);
  const updateReceiveServiceDate = useHomeState(
    (state) => state.updateReceiveServiceDate
  );
  const updateRemarkSale = useHomeState((state) => state.updateRemarkSale);
  const [urlSale, setUrlSale] = useState("");

  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [modalType, setModalType] = useState("");
  const [ddlMasterReason, setDdlMasterReason] = useState<
    OptionMultiLanguageProps[]
  >([]);

  const methodsModal = useForm<any>({
    mode: "onChange",
    defaultValues: {
      caseId: "",
      remarkUs: "",
    },
  });
  const {
    resetField: resetFieldModal,
    watch: watchModal,
    trigger: triggerModal,
    setValue: setValueModal,
  } = methodsModal;

  const methods = useForm<HomeFromProps>({
    mode: "onChange",
    defaultValues: undefined,
  });
  const {
    formState: { errors },
    setValue,
    watch,
  } = methods;

  const columns: ColumnDescription<any, any>[] = [
    {
      dataField: "updateDate",
      text: "วันที่ทำการจองคิว",
      formatter: (cell: any, row: CaseDetail) => {
        return cell;
      },
      align: "center",
    },
    {
      dataField: "transCaseNo",
      text: "Case No",
      formatter: (cell: any, row: CaseDetail) => {
        return (
          <Label
            className="d-flex justify-content-center text-primary"
            style={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={() => showPopup("showDetail", row.id, row)}
          >
            {cell}
          </Label>
        );
      },
    },
    {
      dataField: "fullName",
      text: "ชื่อ - นามสกุล",
      // headerClasses: "text-body-secondary",
      formatter: (cell: any, row: CaseDetail) => {
        // Check if cell has more than 4 characters
        const displayText = cell.length > 4 ? `${cell.slice(0, -4)}xxxx` : cell;

        return (
          <>
            <div className="d-flex justify-content-start form-label">
              {displayText}
              {row.isRsa ? (
                <a
                  href="#"
                  className="btn btn-success btn-sm disabled px-2 ms-2"
                  role="button"
                  aria-disabled="true"
                >
                  RSA
                </a>
              ) : null}
            </div>
          </>
        );
      },
    },

    {
      dataField: "receiveServiceDate",
      text: "วันที่นัดหมาย",
      align: "center",
    },
    {
      dataField: "saleFullName",
      text: "พนักงานขาย",
      align: "center",
    },
    {
      dataField: "statusName",
      align: "center",
      text: "สถานะ",
      formatter: (cell: any, row: CaseDetail) => {
        return (
          <Label
            className={`d-flex justify-content-center badge ${
              cell === "รอวันนัดหมาย" ? "bg-warning" : "bg-danger"
            } text-${cell === "รอวันนัดหมาย" ? "black" : "white"}`}
            style={{ cursor: "pointer", fontSize: "14px", fontWeight: "200" }}
          >
            {cell}
          </Label>
        );
      },
    },
    {
      dataField: "id",
      text: "Action",
      headerClasses: "text-body-secondary",
      formatter: (cell: any, row: CaseDetail) => {
        return (
          <div className="dropdown">
            <button
              className="btn btn-primary btn-sm"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{
                backgroundColor: "transparent",
                color: "black",
                border: "none",
              }}
            >
              <FaEllipsisV />
            </button>
            <ul className="dropdown-menu dropdown-menu-dark">
              <li>
                <a
                  type="button"
                  className="dropdown-item"
                  href={`tel:${row.clientTel}`}
                >
                  โทรติดต่อ
                </a>
              </li>

              {profile().id === row.transSaleId ? (
                <React.Fragment>
                  <li>
                    <a
                      type="button"
                      className="dropdown-item"
                      onClick={() => showPopup("unfollow", cell, row)}
                    >
                      ยกเลิกการติดตาม
                    </a>
                  </li>
                  <li>
                    <a
                      type="button"
                      className="dropdown-item"
                      onClick={() => showPopup("addSaleComment", cell, row)}
                    >
                      เพิ่มบันทึกทีมขาย
                    </a>
                  </li>
                  <li>
                    {row.isRsa === true ? (
                      <a
                        type="button"
                        className="dropdown-item"
                        onClick={() => showPopup("addData", cell, row)}
                      >
                        เพิ่มข้อมูล/ระบุวันนัดหมาย
                      </a>
                    ) : null}
                  </li>
                </React.Fragment>
              ) : (
                <></>
              )}
            </ul>
          </div>
        );
      },
      align: "center",
    },
  ];
  const paginationOptions: PaginationOptions = {
    sizePerPage: 15,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(urlSale).then(
      () => {
        toast.success("Copied Success");
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const onClosePopup = () => {
    resetFieldModal("remarkUs");
    resetFieldModal("unfollowRequest");
    resetFieldModal("updateSaleRemarkRequest");
    resetFieldModal("masterReasonUnfollow");
    resetFieldModal("updateReceiveServiceDateRequest");
    setIsOpenPopup(false);
    setIsOpenPopupAddClient(false);
    setModalType("");
  };

  const onClosePopupAddClient = () => {
    setIsOpenPopupAddClient(false);
  };

  const onSaveModal: SubmitHandler<any> = async (data) => {
    setIsLoading(true);
    if (modalType === "unfollow") {
      data.unfollowRequest.caseId = data.caseId;
      await unfollow(data.unfollowRequest).then((res: ResponseProps) => {
        if (res.data?.code === 200) {
          if (res.data?.status === true) {
            var response = res.data.output.data as UnfollowResponse;
            MySwal.fire({
              icon: "success",
              text: `บันทึกสำเร็จ`,
              confirmButtonText: "ตกลง",
              confirmButtonColor: "#3085d6",
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then(async (result) => {
              onClosePopup();
              onLoadData().then(() => {
                setIsLoading(false);
              });
            });
            setIsLoading(false);
          } else {
            setIsLoading(false);
            toast.error(getMessage(res));
          }
        } else {
          setIsLoading(false);
          toast.error(getMessage(res));
        }
      });
    } else if (modalType === "addSaleComment") {
      data.updateRemarkSale.caseId = data.caseId;
      await updateRemarkSale(data.updateRemarkSale).then(
        (res: ResponseProps) => {
          if (res.data?.code === 200) {
            if (res.data?.status === true) {
              var response = res.data.output.data as UpdateRemarkSaleResponse;
              MySwal.fire({
                icon: "success",
                text: `บันทึกสำเร็จ`,
                confirmButtonText: "ตกลง",
                confirmButtonColor: "#3085d6",
                allowOutsideClick: false,
                allowEscapeKey: false,
              }).then(async (result) => {
                onClosePopup();
                onLoadData().then(() => {
                  setIsLoading(false);
                });
              });
              setIsLoading(false);
            } else {
              setIsLoading(false);
              toast.error(getMessage(res));
            }
          } else {
            setIsLoading(false);
            toast.error(getMessage(res));
          }
        }
      );
    } else if (modalType === "addData") {
      data.updateReceiveServiceDate.caseId = data.caseId;
      data.updateReceiveServiceDate.receiveServiceDate = moment
        .tz(data.updateReceiveServiceDate.receiveServiceDate, "Asia/Bangkok")
        .format("YYYY-MM-DD");
      await updateReceiveServiceDate(data.updateReceiveServiceDate).then(
        (res: ResponseProps) => {
          if (res.data?.code === 200) {
            if (res.data?.status === true) {
              var response = res.data.output
                .data as UpdateReceiveServiceDateResponse;
              MySwal.fire({
                icon: "success",
                text: `บันทึกสำเร็จ`,
                confirmButtonText: "ตกลง",
                confirmButtonColor: "#3085d6",
                allowOutsideClick: false,
                allowEscapeKey: false,
              }).then(async (result) => {
                onClosePopup();
                onLoadData().then(() => {
                  setIsLoading(false);
                });
              });
              setIsLoading(false);
            } else {
              setIsLoading(false);
              toast.error(getMessage(res));
            }
          } else {
            setIsLoading(false);
            toast.error(getMessage(res));
          }
        }
      );
    }
  };

  const onSearch = async () => {
    setIsLoading(true);
    await getCaseFilter(
      profile().id ?? "",
      watch().selectCreateDate,
      watch().textSearch
    ).then(async (caseResponse) => {
      if (caseResponse.data?.code === 200) {
        if (caseResponse.data?.status !== true) {
          toast.error(getMessage(caseResponse));
          await setValue("caseForSale", undefined);
        }
        var casesData = caseResponse.data?.output.data as CaseForSale;
        await setValue("caseForSale", casesData);
      } else {
        // toast.error(getMessage(caseResponse));
        await setValue("caseForSale", undefined);
      }
      setIsLoading(false);
    });
  };

  const onReset = async () => {
    setIsLoading(true);
    await onLoadData();
    await setValue("textSearch", "");
    await setValue("selectCreateDate", [null, null]);
    setIsLoading(false);
  };

  const onLoadData = async () => {
    await getHomePageDetail(profile().id ?? "").then(
      async (getHomePageDetail) => {
        if (getHomePageDetail.data?.code === 200) {
          if (getHomePageDetail.data?.status === true) {
            var data = getHomePageDetail.data?.output.data as CaseForSale;
            await setValue("caseForSale", data);
            setUrlSale(data.urlSale);
          } else {
            toast.error(getMessage(getHomePageDetail));
          }
        } else {
          toast.error(getMessage(getHomePageDetail));
        }
      }
    );
  };

  const loadCountCase = async () => {
    await getCountCase(profile().id ?? "").then(async (getCountCase) => {
      if (getCountCase.data?.code === 200) {
        if (getCountCase.data?.status === true) {
          var data = getCountCase.data?.output.data as CountCase;
          await setValue("countCase", data);
        } else {
          toast.error(getMessage(getCountCase));
        }
      } else {
        toast.error(getMessage(getCountCase));
      }
    });
  };

  const showPopup = async (
    btnName: string,
    caseId: string,
    data: CaseDetail
  ) => {
    setIsOpenPopup(true);
    if (btnName === "unfollow") {
      setModalType("unfollow");
      await getMasterReasonUnfollow().then(async (getMasterReasonUnfollow) => {
        if (getMasterReasonUnfollow.data?.code === 200) {
          if (getMasterReasonUnfollow.data?.status === true) {
            var data = getMasterReasonUnfollow.data?.output
              .data as MasterReasonUnFollow[];
            await setValue("masterReasonUnfollow", data);
            var ddl = data.map((a) => {
              return {
                value: a.id,
                labelTh: a.name,
                labelEn: a.name,
              } as OptionMultiLanguageProps;
            });
            setDdlMasterReason(ddl);
            setValueModal("caseId", caseId);
          } else {
            toast.error(getMessage(getMasterReasonUnfollow));
            setIsOpenPopup(false);
          }
        } else {
          toast.error(getMessage(getMasterReasonUnfollow));
          setIsOpenPopup(false);
        }
      });
    } else if (btnName === "addSaleComment") {
      setModalType("addSaleComment");
      setValueModal("caseId", caseId);
      setValueModal("updateRemarkSale.remark", data.saleRecord);
    } else if (btnName === "addData") {
      setModalType("addData");
      setValueModal("caseId", caseId);
      setValueModal(
        "updateReceiveServiceDate.receiveServiceDate",
        data.receiveServiceDate
      );
    } else if (btnName === "showDetail") {
      setModalType("showDetail");
      setValueModal("caseDetail", data);
    }
  };

  const showPopupAddClient = async () => {
    setIsOpenPopupAddClient(true);
  };

  useEffect(() => {
    setIsLoading(true);
    var gettingData = true;
    if (gettingData) {
      onLoadData();
      loadCountCase().then(() => {
        setIsLoading(false);

        const contractData = watch().countCase?.countContract || [];
        const healingData = watch().countCase?.countHealing || [];
        const allValues = [...contractData, ...healingData].map(v => Number(v) || 0);
        const actualMaxValue = Math.max(...allValues, 0);
        const maxValue = Math.ceil(actualMaxValue * 1.1); // เพิ่ม 10% เผื่อพื้นที่
        const tickAmount = Math.min(8, maxValue);

        setChart({
          ...chartOption,
          series: [
            {
              name: "ยอดการติดต่อ",
              data: contractData,
            },
            {
              name: "ยอดเข้ารับการรักษา",
              data: healingData,
            },
          ],
          yaxis: {
            title: {
              text: "จำนวนผู้เข้ารับบริการ",
              style: {
                fontSize: '14px',
                fontWeight: 600,
              }
            },
            min: 0,
            max: maxValue,
            tickAmount: tickAmount,
            forceNiceScale: false,
            labels: {
              style: {
                fontSize: '12px',
              }
            }
          },
        });
      });
    }
    return () => {
      gettingData = false;
    };
  }, []);

  return (
    <>
      <FormProvider {...methodsModal}>
        <Modal
          backdrop={"static"}
          size={"md"}
          overflow={false}
          keyboard={false}
          open={isOpenPopup}
          onClose={onClosePopup}
        >
          <Modal.Header>
            {modalType === "unfollow" ? (
              <h2>ยกเลิกติดตาม</h2>
            ) : modalType === "addSaleComment" ? (
              <h2>บันทึกเพิ่มเติม</h2>
            ) : modalType === "addData" ? (
              <h2>เพิ่มข้อมูล / ระบุวันนัดหมาย</h2>
            ) : modalType === "showDetail" ? (
              <h2>รายละเอียด</h2>
            ) : null}
          </Modal.Header>
          <Modal.Body>
            {modalType === "unfollow" ? (
              <div className="row">
                <div className="col-12">
                  <InputFieldComponent
                    name="unfollowRequest.masterUnFollowId"
                    label="เหตุผลการเลิกติดตาม"
                    require={true}
                    mode={InputMode.secondary}
                    labelAlignClassName="text-left"
                    labelClassName="col-sm-12"
                    inputClassName="col-sm-12"
                    renderControl={(field) => (
                      <Select
                        {...field}
                        options={ddlMasterReason.map((a) => {
                          return {
                            value: a.value,
                            label: a.labelTh,
                          } as OptionProps;
                        })}
                        onChange={(e) => {
                          const selected = e as OptionProps;
                          resetFieldModal("unfollowRequest.masterUnFollowId");
                          setValueModal(
                            "unfollowRequest.masterUnFollowId",
                            selected.value
                          );
                        }}
                        value={
                          ddlMasterReason
                            .filter((a) => a.value === field.value)
                            ?.map((ct) => {
                              return {
                                value: ct.value,
                                label: ct.labelTh,
                              } as OptionProps;
                            }) || null
                        }
                        isSearchable={true}
                      />
                    )}
                  ></InputFieldComponent>
                </div>
                <div className="col-sm-12">
                  <InputFieldComponent
                    name="unfollowRequest.remarkUnfollow"
                    label="หมายเหตุ"
                    require={true}
                    mode={InputMode.secondary}
                    labelAlignClassName="text-left"
                    labelClassName="col-sm-12"
                    inputClassName="col-sm-12"
                    renderControl={(field) => (
                      <Input
                        type={"textarea"}
                        {...field}
                        autoComplete="off"
                        rows="5"
                      />
                    )}
                  ></InputFieldComponent>
                </div>
              </div>
            ) : modalType === "addSaleComment" ? (
              <div className="row">
                <div className="col-sm-12">
                  <InputFieldComponent
                    name="updateRemarkSale.remark"
                    label="หมายเหตุ"
                    require={true}
                    mode={InputMode.secondary}
                    labelAlignClassName="text-left"
                    labelClassName="col-sm-12"
                    inputClassName="col-sm-12"
                    renderControl={(field) => (
                      <Input
                        type={"textarea"}
                        {...field}
                        autoComplete="off"
                        rows="5"
                      />
                    )}
                  ></InputFieldComponent>
                </div>
              </div>
            ) : modalType === "addData" ? (
              <div className="row">
                <div className="col-sm-12">
                  <InputFieldComponent
                    name="updateReceiveServiceDate.receiveServiceDate"
                    label={"วันนัดหมาย"}
                    mode={InputMode.secondary}
                    labelAlignClassName="text-left"
                    labelClassName="col-sm-12"
                    inputClassName="col-sm-12"
                    renderControl={(field) => (
                      <DatePicker
                        {...field}
                        format="dd/MM/yyyy"
                        placeholder="DD/MM/YYYY"
                        editable={false}
                        className="w-100"
                        oneTap
                        disabled={true}
                        value={field.value ? new Date(field.value) : null}
                      />
                    )}
                  ></InputFieldComponent>
                </div>
              </div>
            ) : modalType === "showDetail" ? (
              <div className="row">
                <div className="col-sm-12">
                  <InputFieldComponent
                    name="caseDetail.lastMonthlyPeriod"
                    label={"ประจำเดือนครั้งล่าสุด"}
                    mode={InputMode.secondary}
                    labelAlignClassName="text-left"
                    labelClassName="col-sm-12"
                    inputClassName="col-sm-12"
                    renderControl={(field) => (
                      <DatePicker
                        {...field}
                        format="dd/MM/yyyy"
                        placeholder="DD/MM/YYYY"
                        editable={false}
                        className="w-100"
                        value={field.value ? new Date(field.value) : null}
                        disabled={true}
                        oneTap
                      />
                    )}
                  ></InputFieldComponent>
                </div>
                <div className="col-sm-12">
                  <InputFieldComponent
                    name="caseDetail.gestationalAge"
                    label="อายุครรภ์(สัปดาห์)"
                    require={true}
                    mode={InputMode.secondary}
                    labelAlignClassName="text-left"
                    labelClassName="col-sm-12"
                    inputClassName="col-sm-12"
                    renderControl={(field) => (
                      <Input
                        type={"text"}
                        value={field.value === 0 ? "N/A" : field.value}
                        disabled={true}
                      />
                    )}
                  ></InputFieldComponent>
                </div>
                <div className="col-sm-12">
                  <InputFieldComponent
                    name="caseDetail.historyOfCesareanSection"
                    label="ประวัติผ่าคลอด"
                    require={true}
                    mode={InputMode.secondary}
                    labelAlignClassName="text-left"
                    labelClassName="col-sm-12"
                    inputClassName="col-sm-12"
                    renderControl={(field) => (
                      <Input type={"text"} {...field} disabled={true} />
                    )}
                  ></InputFieldComponent>
                </div>
                <div className="col-sm-12">
                  <InputFieldComponent
                    name="caseDetail.marriedOrBoyfriend"
                    label="การแต่งงาน / มีแฟน หรือไม่"
                    require={true}
                    mode={InputMode.secondary}
                    labelAlignClassName="text-left"
                    labelClassName="col-sm-12"
                    inputClassName="col-sm-12"
                    renderControl={(field) => (
                      <Input type={"text"} {...field} disabled={true} />
                    )}
                  ></InputFieldComponent>
                </div>
                <div className="col-sm-12">
                  <InputFieldComponent
                    name="caseDetail.drugAllergy"
                    label="ประวัติการแพ้ยา"
                    require={true}
                    mode={InputMode.secondary}
                    labelAlignClassName="text-left"
                    labelClassName="col-sm-12"
                    inputClassName="col-sm-12"
                    renderControl={(field) => (
                      <Input type={"text"} {...field} disabled={true} />
                    )}
                  ></InputFieldComponent>
                </div>
                <div className="col-sm-12">
                  <InputFieldComponent
                    name="caseDetail.congenitalDisease"
                    label="โรคประจำตัว"
                    require={true}
                    mode={InputMode.secondary}
                    labelAlignClassName="text-left"
                    labelClassName="col-sm-12"
                    inputClassName="col-sm-12"
                    renderControl={(field) => (
                      <Input type={"text"} {...field} disabled={true} />
                    )}
                  ></InputFieldComponent>
                </div>
                <div className="col-sm-12">
                  <InputFieldComponent
                    name="caseDetail.reasonTermination"
                    label="เหตุผลในการยุติ"
                    require={true}
                    mode={InputMode.secondary}
                    labelAlignClassName="text-left"
                    labelClassName="col-sm-12"
                    inputClassName="col-sm-12"
                    renderControl={(field) => (
                      <Input type={"text"} {...field} disabled={true} />
                    )}
                  ></InputFieldComponent>
                </div>
                <div className="col-sm-12">
                  <InputFieldComponent
                    name="caseDetail.informationToDoctor"
                    label="ข้อมูลเพิ่มเติมถึงแพทย์"
                    require={true}
                    mode={InputMode.secondary}
                    labelAlignClassName="text-left"
                    labelClassName="col-sm-12"
                    inputClassName="col-sm-12"
                    renderControl={(field) => (
                      <Input
                        type={"textarea"}
                        {...field}
                        autoComplete="off"
                        rows="5"
                        disabled={true}
                      />
                    )}
                  ></InputFieldComponent>
                </div>
              </div>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            {modalType !== "" ? (
              <>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onClosePopup}
                >
                  ยกเลิก
                </button>
                {modalType !== "showDetail" ? (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={async () => {
                      const isValid = await triggerModal();
                      if (isValid) {
                        onSaveModal(watchModal());
                      }
                    }}
                  >
                    ยืนยัน
                  </button>
                ) : null}
              </>
            ) : null}
          </Modal.Footer>
          <JsonViewerComponent data={watchModal()}></JsonViewerComponent>
        </Modal>
      </FormProvider>

      <FormProvider {...methods}>
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <div>
              <div className="row mb-3">
                <div className="col-md-3 col-sm-6 pt-2">
                  <div className="card border-5 border-danger border-start-0 border-end-0 border-top-0 shadow-sm h-100">
                    <div className="card-body d-flex flex-column justify-content-between">
                      <h6 className="card-subtitle mb-3 text-muted">
                        ยอดการนัดหมายของทีมปีนี้
                      </h6>
                      <h2
                        className="card-title mb-0"
                        style={{ textAlign: "center", fontSize: "3rem" }}
                      >
                        <span
                          className="card-text"
                          style={{ fontWeight: "bold", color: "#dc3545" }}
                        >
                          {watch().countCase?.countCaseYear}
                        </span>
                      </h2>
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 pt-2">
                  <div className="card border-5 border-success border-start-0 border-end-0 border-top-0 shadow-sm h-100">
                    <div className="card-body d-flex flex-column justify-content-between">
                      <h6 className="card-subtitle mb-3 text-muted">
                        ยอดเข้ารับบริการของทีมเดือนนี้
                      </h6>
                      <h2
                        className="card-title mb-0"
                        style={{ textAlign: "center", fontSize: "3rem" }}
                      >
                        <span
                          className="card-text"
                          style={{ fontWeight: "bold", color: "#28a745" }}
                        >
                          {watch().countCase?.countCaseCureMonth}
                        </span>
                      </h2>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <div className="card border-0 shadow-sm">
                    <div className="card-body">
                      <div className="row justify-content-between">
                        <h5>
                          กราฟเปรียบเทียบยอดการนัดหมายและยอดเข้ารับบริการของทีม
                        </h5>

                        <div className="col-12">
                          <div>
                            <Chart
                              options={chart}
                              series={chart.series}
                              type="line"
                              height={350}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <br />
              <br />
              <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-7 pt-3">
                  <h6>
                    รายชื่อการนัดหมายรอเข้ารับบริการของทีม(
                    {watch().caseForSale?.countCaseFilter})
                  </h6>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-5">
                  <div
                    className="d-flex align-items-end"
                    style={{ float: "right" }}
                  >
                    {/* <button
                      type="button"
                      title="Clipboard"
                      className="btn btn-success me-2 mb-3" // Add margin to the right for spacing
                      onClick={showPopupAddClient}
                    >
                      <BsBuildingAdd /> เพิ่มคนไข้
                    </button> */}

                    <button
                      type="button"
                      title="Clipboard"
                      className="btn btn-primary me-2 mb-3" // Add margin to the right for spacing
                      onClick={copyToClipboard}
                    >
                      <BsCopy /> Your ref URL
                    </button>

                    <InputFieldComponent
                      name="textSearch"
                      mode={InputMode.secondary}
                      labelAlignClassName="text-left"
                      labelClassName="d-none" // Hide the label to keep it inline
                      inputClassName="flex-grow-1" // Allow the input to take remaining space
                      renderControl={(field) => (
                        <Input
                          type="text"
                          {...field}
                          className="form-control"
                          autoComplete="off"
                          placeholder="Search"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault(); // Prevent default form submission
                              onSearch(); // Call the onSearch function
                            }
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card border-0 shadow-sm">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-12">
                          <div className="table-responsive">
                            {" "}
                            <BootstrapTable
                              keyField="id"
                              data={watch().caseForSale?.caseDetailData || []}
                              hover
                              condensed
                              noDataIndication={() => (
                                <div className="text-center">ไม่มีข้อมูล</div>
                              )}
                              headerClasses="text-center"
                              pagination={paginationFactory(paginationOptions)}
                              columns={columns}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <JsonViewerComponent data={profile()}></JsonViewerComponent>
        <JsonViewerComponent data={watch()}></JsonViewerComponent>
        <JsonViewerComponent data={errors}></JsonViewerComponent>
      </FormProvider>

      <Modal
        backdrop={"static"}
        size={"md"}
        overflow={false}
        keyboard={false}
        open={isOpenPopupAddClient}
        onClose={onClosePopupAddClient}
      >
        <Modal.Header>เพิ่มคนไข้</Modal.Header>
        <Modal.Body>
          <ModalAddClient
            isOpenPopupAddClient={isOpenPopupAddClient}
            setIsOpenPopupAddClient={setIsOpenPopupAddClient}
          />
        </Modal.Body>
        <Modal.Footer>
          {modalType !== "" ? (
            <>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClosePopup}
              >
                ยกเลิก
              </button>
              {modalType !== "showDetail" ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={async () => {
                    const isValid = await triggerModal();
                    if (isValid) {
                      onSaveModal(watchModal());
                    }
                  }}
                >
                  ยืนยัน
                </button>
              ) : null}
            </>
          ) : null}
        </Modal.Footer>
        <JsonViewerComponent data={watchModal()}></JsonViewerComponent>
      </Modal>
    </>
  );
};

export default Home;
